import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { CARET } from 'enums';
import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';
import { useHoverTooltip } from 'framework/Tooltip/hooks/useHoverTooltip';
import { TooltipProps } from 'framework/Tooltip/types';

import cn from './Tooltip.module.scss';

export const Tooltip = ({
  information = '',
  width = 'fit-content',
  theme,
  children,
}: TooltipProps) => {
  const { is_open, caret, triggerRef, tooltipRef } = useHoverTooltip();
  const field_theme = useFieldTheme(theme);

  const content = (
    <div
      ref={tooltipRef}
      className={cn.tooltip}
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        width,
        background: field_theme.background.normal,
        border: field_theme.border.normal,
      }}
    >
      <span
        className={classNames(cn.caret, {
          [cn.top]: caret === CARET.TOP,
          [cn.right]: caret === CARET.RIGHT,
          [cn.bottom]: caret === CARET.BOTTOM,
          [cn.left]: caret === CARET.LEFT,
        })}
      />
      {information}
    </div>
  );

  return (
    <>
      <div ref={triggerRef}>{children}</div>
      {is_open && !!information && createPortal(content, document.body)}
    </>
  );
};
